module.exports = __webpack_public_path__ + "static/media/floorplan-sketch.51b21a8f.png";